<template>
    <div class="product-listings">
        <transition name="fade" mode="out-in">
            <div
                :key="items.map(({ name }) => name).join('-')"
            >
                <no-results
                    v-if="!items.length"
                />
                <b-row v-else>
                    <b-col
                        v-for="item in items"
                        :key="item.name ? item.name.replace(/\s/g, '-') : item.to"
                        cols="6"
                        :md="12 / columns"
                        class="item"
                    >
                        <product-listing-card
                            :image="item.image"
                            :name="item.name"
                            :calories="item.calories"
                            :fibre="item.fibre"
                            :protein="item.protein"
                            :plant-points="item.plant_points"
                            :to="item.to"
                            :dietary-labels="item.dietaryLabels"
                            :stat-to-show="statToShow"
                        />
                    </b-col>
                </b-row>
            </div>
        </transition>
    </div>
</template>

<script>
    import ProductListingCard from '../ProductListingCard/ProductListingCard';
    import NoResults from '../NoResults/NoResults';

    export default {
        name: 'product-listings',

        components: { NoResults, ProductListingCard },

        props: {
            items: {
                type: Array,
                default: () => ([]),
            },

            statToShow: {
                type: String,
                default: 'calories',
            },

            columns: {
                type: Number,
                default: 3,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .product-listings {
        min-height: 450px;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: 0.5s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .item {
        margin-bottom: 24px;
    }
</style>
